import React, { Component } from 'react';
import { calcX } from './SVGUtils.js';
import { getGameTime } from './Utils.js';

class StockGrid extends Component {
    static defaultProps = {
        width:1920,
        minWidth:600,
        padding:30,
        maxPercent:300,
        yGrid:90,
        stocks:2,
        scrollOffset:0,
        characters:2,
        compressedTime:false
    };

    constructor(props){
        super(props);

        // width of the drawn svg
        this.state = {showPercents: true};
        this.svgWidth = 1920;
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    renderGrid(stock, offset) {
        let numGrids = Math.ceil(this.props.maxPercent/100.0);
        let yGrid = this.props.yGrid;
        let height = yGrid * numGrids;
        let parts = [];

        offset = "translate(0, " + ((offset+(this.props.stocks-1))*height) + ")";

        for(let i=0; i<numGrids; i++) {
            let lineType = i === 0 ? "minor-grid" : "minor-grid-2";
            parts.push(<line key={"part" + i} className={lineType} x1="0" x2={this.svgWidth} y1={i*yGrid} y2={i*yGrid} />);
            parts.push(<text key={"parttext" + i} fill="#555" fontSize="14" fontWeight="500" x="5" y={15+yGrid*i}>{this.props.maxPercent-i*100}%</text>);
        }
        if (this.props.stocks !== 1) {
            parts.push(<text className="grid-stock-text" x="3" y={height-10}>STOCK {stock}</text>);
        }

        return (
            <g key={"grid" + stock + "+" + offset} transform={offset}>
              {parts}
              {stock === 1 && <line className="major-grid" x1="0" x2={this.svgWidth} y1={height} y2={height} />}
            </g>
        );
    }

    getX(x) {
        if (this.svg) {
            let pt = this.svg.createSVGPoint();
            pt.x = x;
            pt = pt.matrixTransform(this.svg.getScreenCTM().inverse());
            return pt.x;
        } else {
            return x;
        }
    }

    render() {
        let maxMinutes = this.props.minutes;
        let gridLength = this.props.compressedTime ? this.props.length : maxMinutes * 60;
        let numGrids = Math.ceil(this.props.maxPercent/100.0);
        let stocks = this.props.stocks;
        let yGrid = this.props.yGrid * numGrids;
        let viewBox = "0 0 " + (this.props.width + this.props.padding*2) + " " + (yGrid*stocks + this.props.padding*2);
        let minutes = [];
        let w = this.props.width;
        let minW = this.props.minWidth;

        let minutesTest = this.props.compressedTime ? Math.trunc(this.props.length/60) : 5;

        for(let i=0; i<minutesTest; i++) {
            let x = 1920.0 / gridLength * i * 60.0;
            let xPos = calcX(x, w, this.svgWidth, minW);
            minutes.push(<line key={"minute-" + i} className="minor-grid" x1={xPos} x2={xPos} y1={0} y2={yGrid*stocks} />);

            if (i > 0) {
                minutes.push(<text key={"minute-anchor-" + i} textAnchor="middle" fill="#555" fontSize="14" fontWeight="600" x={xPos} y={yGrid*stocks+20}>{i}:00</text>);
            }
        }

        let finalMarker = this.props.compressedTime ? getGameTime(this.props.length, false) : getGameTime(gridLength, false);
        minutes.push(<line key="minutes-line" className="minor-grid" x1={1920} x2={1920} y1={0} y2={yGrid*stocks} />);
        minutes.push(<text key="minutes-text" textAnchor="middle" fill="#555" fontSize="14" fontWeight="600" x={calcX(1920, w, this.svgWidth, minW)} y={yGrid*stocks+20}>{finalMarker}</text>);

        let grids = [];
        for(let i=0; i<stocks; i++) {
            grids.push(this.renderGrid(i+1, -i));
        }

        let mouseX = this.getX(this.props.hoverX);
        let hoverSecond = mouseX / (1920.0 / gridLength);
        hoverSecond = Math.min(gridLength, hoverSecond);
        mouseX = Math.max(0, Math.min(1920, mouseX)); // contain mouse position to within the grid
        
        let paddingTranslate = "translate(" + this.props.padding + "," + (this.props.padding + this.props.scrollOffset*2) + ")";

        let percents = [];
        if (this.props.characters > 2) {
            percents.push(<text key="p1_percent" textAnchor="middle" x={106+80*0} y={122} >{this.props.getPercent(2, hoverSecond)}%</text>);
            percents.push(<text key="p1_score" textAnchor="middle" x={106+80*0} y={102} >{this.props.getScore(2, hoverSecond)}</text>);

            percents.push(<text key="p2_percent" textAnchor="middle" x={106+80*1} y={122} >{this.props.getPercent(3, hoverSecond)}%</text>);
            percents.push(<text key="p2_score" textAnchor="middle" x={106+80*1} y={102} >{this.props.getScore(3, hoverSecond)}</text>);

            percents.push(<text key="p3_percent" textAnchor="middle" x={106+80*2 + 40} y={122} >{this.props.getPercent(0, hoverSecond)}%</text>);
            percents.push(<text key="p3_score" textAnchor="middle" x={106+80*2 + 40} y={102} >{this.props.getScore(0, hoverSecond)}</text>);

            percents.push(<text key="p4_percent" textAnchor="middle" x={106+80*3 + 40} y={122} >{this.props.getPercent(1, hoverSecond)}%</text>);
            percents.push(<text key="p4_score" textAnchor="middle" x={106+80*3 + 40} y={102} >{this.props.getScore(1, hoverSecond)}</text>);
        } else {
            percents.push(<text key="p1_percent" textAnchor="middle" x={106+80*0} y={122} >{this.props.getPercent(1, hoverSecond)}%</text>);
            percents.push(<text key="p1_score" textAnchor="middle" x={106+80*0} y={102} >Stock {this.props.getScore(1, hoverSecond)}</text>);

            percents.push(<text key="p2_percent" textAnchor="middle" x={106+80*1 + 40} y={122} >{this.props.getPercent(0, hoverSecond)}%</text>);
            percents.push(<text key="p2_score" textAnchor="middle" x={106+80*1 + 40} y={102} >Stock {this.props.getScore(0, hoverSecond)}</text>);
        }

        percents.push(<text key="time-label" textAnchor="middle" x={35} y={52} >Time</text>);
        percents.push(<text key="time-data" textAnchor="middle" x={35} y={72} >{getGameTime(hoverSecond, false)}</text>);
        percents.push(<text key="score-label" textAnchor="middle" x={35} y={102} >Score</text>);
        percents.push(<text key="percent-label" textAnchor="middle" x={35} y={122} >Percent</text>);

        let hoverInfo = (hoverSecond <= gridLength * 60 && hoverSecond >= 0 &&
                         <line className="percent-line" x1={mouseX} x2={mouseX} y1={0} y2={yGrid} />);

        return (
            <svg className="StockGrid" viewBox={viewBox} ref={c => this.svg = c}>
              <g transform={paddingTranslate}>
                <rect className="background" x={0} y={0} width={1920} height={yGrid*stocks} />
                { minutes }
                { hoverInfo }
                { this.props.children }
                { this.state.showPercents &&
                    percents
                }
                { grids }
              </g>
            </svg>
        );
    }
}

export default StockGrid;

